/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".red-error[_ngcontent-%COMP%] {\r\n    width: 100% !important;\r\n    position: fixed !important;\r\n    z-index: 9999 !important;\r\n    top: 0 !important;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n    .hdr-menu-fixed[_ngcontent-%COMP%] {\r\n        position: inherit;\r\n    }\r\n}"];
export { styles as styles };
